import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Graphics } from "constant";
import Button from "module-common/Button";

const Routes = {
  "401": {
    message: "Unauthorized Access Detected",
    button: "LOGIN",
    path: "/login"
  },
  "404": {
    message: "Sorry, The Page You Are Looking For Was Not Found",
    button: "TAKE ME HOME",
    path: "/case-management"
  },
  "502": {
    message: "App Under Maintenance",
    button: "Try Again",
    path: "/case-management"
  }
};

export default class ErrorScreen extends Component {
  static propTypes = { code: PropTypes.number };
  static defaultProps = { code: 404 };

  render() {
    let route = Routes[this.props.code];
    if (!route) route = Routes["404"];
    return (
      <Wrapper>
        <Content>
          <Image />
          <Info>
            <Code>{this.props.code}</Code>
            <Message>{route.message}</Message>
            <StyledButton
              rounded
              onClick={() => (window.location = route.path)}
            >
              {route.button}
            </StyledButton>
          </Info>
        </Content>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 55px solid ${props => props.theme.blueButton};
`;
const Content = styled.div`
  display: flex;
  flex-direction: row;
`;
const Image = styled.img.attrs({ alt: "", src: Graphics["error-screen"] })`
  self-align: flex-start;
  margin-right: 40px;
`;
const Info = styled.div`
  display: flex;
  flex-direction: column;
`;
const Code = styled.div`
  color: ${props => props.theme.blueButton};
  font-size: 9rem;
  font-weight: bold;
  font-family: arial;
  border-left: 2px solid ${props => props.theme.blueButton};
  padding-left: 40px;
  line-height: 0.8;
`;
const Message = styled.div`
  color: #8b9aa6;
  font-size: 1.5rem;
  border-left: 2px solid ${props => props.theme.blueButton};
  padding-left: 40px;
  padding-top: 30px;
  width: 360px;
`;
const StyledButton = styled(Button).attrs({ size: "large" })`
  font-size: 1.2rem;
  height: 40px;
  width: 210px;
  margin-top: 20px;
  margin-left: 40px;
`;



// WEBPACK FOOTER //
// ./src/module-common/ErrorScreen.js